
import { BaseBackgroundEffect } from '@/render/background/BaseBackgroundEffect';
import { BackgroundContext } from '@/render/background/BackgroundEffect';

export class LinearGradientBackground extends BaseBackgroundEffect {
    public render(bc: BackgroundContext): void {
        const { ctx, width, height, config } = bc;
        const angle = (config.backgroundAngle || 0) * Math.PI / 180;
        
        const x2 = width * Math.cos(angle);
        const y2 = height * Math.sin(angle);
        
        const grad = ctx.createLinearGradient(0, 0, x2, y2);
        grad.addColorStop(0, this.getPrimaryColor(bc));
        grad.addColorStop(1, this.getSecondaryColor(bc));
        
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, width, height);
    }
}
